module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rents-quantities"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-2"
  }, [_c('button', {
    staticClass: "text-center btn btn-default btn-block status-1",
    class: {
      active: this.statusId == 1
    },
    on: {
      "click": function($event) {
        return _vm.navigate(1)
      }
    }
  }, [(_vm.rentsStatus[1] != null) ? _c('strong', [_vm._v(_vm._s(_vm.rentsStatus[1]))]) : _c('strong', [_c('i', {
    staticClass: "fa fa-fw fa-lg fa-spin fa-spinner"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("NOVAS")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2"
  }, [_c('button', {
    staticClass: "text-center btn btn-default btn-block status-3",
    class: {
      active: this.statusId == 3
    },
    on: {
      "click": function($event) {
        return _vm.navigate(3)
      }
    }
  }, [(_vm.rentsStatus[3] != null) ? _c('strong', [_vm._v(_vm._s(_vm.rentsStatus[3]))]) : _c('strong', [_c('i', {
    staticClass: "fa fa-fw fa-lg fa-spin fa-spinner"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("CONFIRMADAS")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2"
  }, [_c('button', {
    staticClass: "text-center btn btn-default btn-block status-4",
    class: {
      active: this.statusId == 4
    },
    on: {
      "click": function($event) {
        return _vm.navigate(4)
      }
    }
  }, [(_vm.rentsStatus[4] != null) ? _c('strong', [_vm._v(_vm._s(_vm.rentsStatus[4]))]) : _c('strong', [_c('i', {
    staticClass: "fa fa-fw fa-lg fa-spin fa-spinner"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("TRANSPORTE")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2"
  }, [_c('button', {
    staticClass: "text-center btn btn-default btn-block status-5",
    class: {
      active: this.statusId == 5
    },
    on: {
      "click": function($event) {
        return _vm.navigate(5)
      }
    }
  }, [(_vm.rentsStatus[5] != null) ? _c('strong', [_vm._v(_vm._s(_vm.rentsStatus[5]))]) : _c('strong', [_c('i', {
    staticClass: "fa fa-fw fa-lg fa-spin fa-spinner"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("INICIADAS")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2"
  }, [_c('button', {
    staticClass: "text-center btn btn-default btn-block status-6",
    class: {
      active: this.statusId == 6
    },
    on: {
      "click": function($event) {
        return _vm.navigate(6)
      }
    }
  }, [(_vm.rentsStatus[6] != null) ? _c('strong', [_vm._v(_vm._s(_vm.rentsStatus[6]))]) : _c('strong', [_c('i', {
    staticClass: "fa fa-fw fa-lg fa-spin fa-spinner"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("FINALIZADAS")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2"
  }, [_c('button', {
    staticClass: "text-center btn btn-default btn-block status-7",
    class: {
      active: this.statusId == 7
    },
    on: {
      "click": function($event) {
        return _vm.navigate(7)
      }
    }
  }, [(_vm.rentsStatus[7] != null) ? _c('strong', [_vm._v(_vm._s(_vm.rentsStatus[7]))]) : _c('strong', [_c('i', {
    staticClass: "fa fa-fw fa-lg fa-spin fa-spinner"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("PENDENTES")])])])]), _vm._v(" "), _c('audio', {
    ref: "newRents",
    attrs: {
      "src": _vm.cdn('sound.mp3')
    }
  }), _vm._v(" "), _c('audio', {
    ref: "newRentSound",
    attrs: {
      "src": _vm.cdn('beep.mp3')
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3758a99e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/QuantityRents.vue
// module id = 983
// module chunks = 34